module.exports = __webpack_public_path__ + "assets/cupon-4bbc42.svg";